import eliteService from "../api/elite-service";
import redirect from "../uitls/redirect";
import { MESSAGES } from "../uitls/messages";
import { notifyError } from "../uitls/notification-helper";
import retry from "@/utils/retry";

const storeStitchedVideos = {
  // videoIdA stitched x times sequentially
  3248: [{2407:1}, {2410:1}, {2407:1}, {2410:1}, {2409:1}, {2410:1}, {2409:2}]
}

const getState = () => {
  return {
    // indicator
    loading: false,
    videoIdSeq: null,
    // video
    seq: 0,
    videoId: null,
    baselineFolder: null,
    duration: null,
    intensity: null,
    scoringLogic: null,
    workoutStartTime: null,
    workoutEndTime: null,
    prevVideosTotalDuration: 0,
    steps: [],
    data: null,
    // upgs
    requestCount: 0,
    oldAccuracy: 0,
    oldCalories: 0,
    timeLapsed: 0,
    // prefetch
    nextVideo: null,
  };
};

const state = {
  ...getState(),
};

const mutations = {
  resetState(state) {
    Object.assign(state, getState());
  },
  setWorkout(state, data) {
      let videoIdSeq = [];
      storeStitchedVideos[data.playingVideoId]
      .forEach( obj => {
        let videoId = +parseInt(Object.keys(obj)[0]);
        videoIdSeq = [...videoIdSeq, ...Array(obj[videoId]).fill(videoId)];
      });
      state.videoIdSeq = videoIdSeq;
  },
  setVideo(state, data) {
      state.seq = state.seq + 1;
      state.prevVideosTotalDuration += +state.duration; 
      state.videoId = +data.videoId;
      state.baselineFolder = data.baselineFolder;
      state.duration = +data.duration;
      state.intensity = +data.intensity;
      state.scoringLogic = data.scoringLogic;
      state.data = data?.data;
      state.workoutStartTime = +data?.data.start;
      state.workoutEndTime = +data?.data.end;
      state.steps = data?.data.steps.map(step => {
        return {...step, start: +step.start + state.prevVideosTotalDuration, end: +step.end + state.prevVideosTotalDuration}
      });
  },
  setNextScore(state, data) {
      state.requestCount= data.requestCount + 1;
      state.oldAccuracy = data.oldAccuracy;
      state.oldCalories = data.oldCalories;
      state.timeLapsed  = data.timeLapsed;
  },
  storeNextVideo(state, data) {
    state.nextVideo = data;
  },
  setLoading(state, isLoading) {
    state.loading = isLoading;
  }
};

const getters = {
  isMVWLoading(state) {
    return state.loading;
  },
  isLastVideo(state) {
    return state.seq == state.videoIdSeq.length;
  },
  getVideo(state) {
    return {
        seq: state.seq,
        elapsedDuration: state.prevVideosTotalDuration,
        videoId: state.videoId,
        baselineFolder: state.baselineFolder,
        duration: state.duration,
        intensity: state.intensity,
        scoringLogic: state.scoringLogic,
        workoutStartTime: state.workoutStartTime,
        workoutEndTime: state.workoutEndTime,
        steps: state.steps,
    }
  },
  getNextVideo(state) {
    return state.nextVideo;
  },
  getOldScore(state) {
      return {
          requestCount: state.requestCount,
          oldAccuracy: state.oldAccuracy,
          oldCalories: state.oldCalories,
          timeLapsed: state.timeLapsed,
      }
  },
  getStoredStitchedVideos() {
    return storeStitchedVideos;
  }
};

const actions = {
  async initMultiVideoWorkout({ commit, dispatch }, data) {
    commit("setLoading", true);
    commit("resetState");
    commit("setWorkout", data);
    await dispatch("loadNextVideo")
    .then(async _ => await dispatch("moveToNextVideo"));
    commit("setLoading", false);
  },
  async loadNextVideo({ commit, state }) {
    if (state.seq >= state.videoIdSeq.length) return;
    const id = state.videoIdSeq[state.seq];
    if (state.videoId && id == state.videoId) {
      commit("setLoading", true);
      commit("storeNextVideo", {...state});
      commit("setLoading", false);
      return;
    }
      commit("setLoading", true);
    try {
      const videoData = await eliteService.getVideoInfo(id)
      .then(data => { return {...data, videoId: data.id}});
  
      commit("storeNextVideo", videoData);
      console.log('trying to get next video', id);
      return videoData;
    } catch (e) {
      try {
        await retry(e);
        const videoData = await eliteService.getVideoInfo(id)
        .then(data => { return {...data, videoId: data.id}});
        commit("storeNextVideo", videoData);
        return videoData;
      } catch {
        redirect(e);
        notifyError(MESSAGES.LOAD_VIDEO_FAILED);
        Promise.reject(e);
      }
    } finally {
      commit("setLoading", false);
    }
  },
  async moveToNextVideo({ commit, state, dispatch }) {
    commit("setLoading", true);
    console.log('switching next video', state.nextVideo.videoId);
    commit("setVideo", state.nextVideo);
    commit("storeNextVideo", null);
    dispatch("updateViewCount");
    commit("setLoading", false);
  },
  async updateViewCount({ state }) {
    try {
      await eliteService.updateVideoViews(state.videoId);
    } catch (e) {
      retry(e).then(async (_) => {
        await eliteService.updateVideoViews(state.videoId);
      });
    }
  },
  checkMultiVideoWorkout({ state }, playingVideoId) {
    return !!storeStitchedVideos[playingVideoId];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {},
};
